export default {
  helpText: 'Bitte wählen und sortieren Sie die Spalten, die Sie in der Auftragsübersichtstabelle anzeigen möchten. Diese Einstellung gilt global für alle Benutzer.',
  selectedColumns: 'Ausgewählte Spalten',
  nonSelectedColumns: 'Verfügbare Spalten',
};
